import { IAppState } from '../../redux';

export const selectIsArchived = (state: IAppState): boolean => {
  return state.offer.isArchived;
};
